import React, { useState } from "react";
import "./domestico.css";
import DataCollection from "./data-collection/data-collection";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import axios from "axios";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

const Domestico = () => {
  // variables
  const [show_form, set_show_form] = useState(true);
  const { handleSubmit, register } = useForm();
  const [awbId, setAwbId] = useState("");
  //funciones
  const changeViewForm = async (data) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/nationals/findMaster`,
        data,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      set_show_form(false);
      setAwbId(response.data.data.fwb_id);
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error",
        text: error.response.data.message,
        icon: "error",
      });
    }
  };

  //renders o vistas
  const view_form = (
    <>
      <ScrollToTop />
      <div className="col-md-6 offset-3 text-center">
        <form
          onSubmit={handleSubmit(changeViewForm)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
        >
          <div className="row mt-3">
            <div className="form-group col-12 mb-3 text-start">
              <label className="bolder mb-2" htmlFor="awb">
                <b>Ingrese número de guía</b>
              </label>
              <input
                id="awb"
                className="form-control"
                type="text"
                name="awb"
                {...register("awb", {
                  required: true,
                })}
              ></input>
            </div>

            <div className="form-group col-md-12 mb-4">
              <div className="ms-auto text-end">
                <button
                  type="submit"
                  className="btn btn-primary custom-background"
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );

  //vista final
  return (
    <div className="row">
      <div className="col-md-12">
        <section className="container awb-container">
          <div className="row">
            {show_form ? (
              view_form
            ) : (
              <DataCollection awbId={awbId} set_show_form={set_show_form} />
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Domestico;
